import { useContext, useEffect, useState } from "react";
import { apiGet } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";

export default function useEmployeeEnrollments(employeeId) {
    const { companyId } = useContext(PrivateRoutesContext);

    const [planPeriods, setPlanPeriods] = useState([]);
    const [selectedPlanPeriod, setSelectedPlanPeriod] = useState('');
    const [allBenefitPeriods, setAllBenefitPeriods] = useState([]);
    const [benefitPeriods, setBenefitPeriods] = useState([]);
    const [selectedBenefitPeriod, setSelectedBenefitPeriod] = useState('');
    const [enrollments, setEnrollments] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const refetchDropdowns = () => {
        if (!employeeId) return;

        apiGet(apiUrls.getEmpBenefitsDropdowns(employeeId)).then((response) => {
            setPlanPeriods(response.data);

            if (response.data.length > 0) {
                setSelectedPlanPeriod(response.data[0].planPeriodId);
            }
        })
        .catch(() => {});
    };

    useEffect(() => {
        refetchDropdowns();
    }, [employeeId]);

    useEffect(() => {
        if (!companyId) return;

        apiGet(apiUrls.getBenefitPayPeriods(companyId)).then((response) => {
            setAllBenefitPeriods(response.data);
        })
        .catch(() => {});
    }, [companyId]);

    useEffect(() => {
        var pp = planPeriods.find(p => p.planPeriodId === selectedPlanPeriod);

        if (pp) {
            var bp = allBenefitPeriods.filter(a => new Date(pp.beginDate) <= new Date(a.benefitDate) && new Date(a.benefitDate) <= new Date(pp.endDate));

            setBenefitPeriods(bp);
        }
    }, [selectedPlanPeriod, allBenefitPeriods]);

    useEffect(() => {
        if (benefitPeriods.length > 0) {
            let closed = benefitPeriods.filter(x => x.statusCode === 'CLOSE');
            if (closed.length === 0) {
                let currentTime = new Date();
                let latest = benefitPeriods.filter(x => Date.parse(x.benefitDate) < currentTime);

                if (latest.length === 0) {
                    setSelectedBenefitPeriod(benefitPeriods[0].payPeriodID);
                }
                else {
                    setSelectedBenefitPeriod(latest[0].payPeriodID);
                }
            }
            else {
                setSelectedBenefitPeriod(closed[0].payPeriodID);
            }
        }
    }, [benefitPeriods]);

    useEffect(() => {
        if (!employeeId || !selectedBenefitPeriod) return;

        setIsLoading(true);

        apiGet(apiUrls.getEmpEnrollments(employeeId, selectedBenefitPeriod)).then((response) => {
            setEnrollments(response.data);
            setIsLoading(false);
        })
        .catch(() => {
            setIsLoading(false);
        });
    }, [employeeId, selectedBenefitPeriod]);

    const activeBenefits = enrollments.filter(e => e.status === "Active");

    return {
        planPeriods,
        selectedPlanPeriod,
        setSelectedPlanPeriod,
        allBenefitPeriods,
        benefitPeriods,
        selectedBenefitPeriod,
        setSelectedBenefitPeriod,
        enrollments,
        activeBenefits,
        isLoading,
        refetchDropdowns,
    };
}
